import { Navbar, Nav, Container, NavDropdown, Form } from 'react-bootstrap'
import NotificationBell from '../Notifications/NotificationBell'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { tieneModulo } from '../../utils/modulos'
import { useClientFilter } from '../../hooks/useClientFilter'
import { getDjangoAdminUrl } from '../../utils/djangoAdminUrl'
import './Layout.css'

// Financiero mezcla cuatro productos distintos bajo un mismo menú: basta tener uno para que
// la entrada aparezca, y adentro cada pestaña se filtra por su cuenta.
const MODULOS_FINANCIEROS = ['facturacion', 'bancos', 'cobranza', 'presupuestos']

const Layout = ({ children }) => {
  const { isAuthenticated, user, logout, isSuperuser } = useAuth()
  const {
    selectedClientId,
    setSelectedClientId,
    clients,
    isLoadingClients,
    clientLabel,
    isFiltering,
  } = useClientFilter()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className="layout">
      <Navbar bg="primary" variant="dark" expand="lg" className="main-navbar">
        <Container fluid>
          <Navbar.Brand as={Link} to="/">
            <img
              src="/logo.png"
              alt="Arithmos"
              height="30"
              className="d-inline-block align-top me-2"
              onError={(e) => {
                e.target.style.display = 'none'
              }}
            />
            Arithmos
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              {isAuthenticated && (
                <>
                  <Nav.Link as={Link} to="/dashboard">
                    Dashboard
                  </Nav.Link>
                  {/* El menú muestra lo que el plan incluye. Clientes va siempre: sin
                      contribuyentes no hay nada que facturar. */}
                  <Nav.Link as={Link} to="/clients">
                    Clientes
                  </Nav.Link>
                  {tieneModulo(user, 'contabilidad') && (
                    <Nav.Link as={Link} to="/accounting">
                      Contabilidad
                    </Nav.Link>
                  )}
                  {MODULOS_FINANCIEROS.some((m) => tieneModulo(user, m)) && (
                    <Nav.Link as={Link} to="/financial">
                      Financiero
                    </Nav.Link>
                  )}
                  {tieneModulo(user, 'reportes') && (
                    <Nav.Link as={Link} to="/reports">
                      Reportes
                    </Nav.Link>
                  )}
                  {tieneModulo(user, 'nomina') && (
                    <Nav.Link as={Link} to="/nomina/auditoria">
                      Nómina
                    </Nav.Link>
                  )}
                  {/* Su plan: lo ve cualquiera que tenga licencia. Para los contadores
                      internos --capacidad ilimitada-- la pantalla igual sirve de referencia. */}
                  {user?.role === 'contador' && (
                    <Nav.Link as={Link} to="/mi-plan">
                      <i className="bi bi-card-checklist me-1"></i> Mi plan
                    </Nav.Link>
                  )}
                  {(isSuperuser || user?.role === 'superadmin') && (
                    <Nav.Link as={Link} to="/licenciamiento">
                      <i className="bi bi-key me-1"></i> Licenciamiento
                    </Nav.Link>
                  )}
                </>
              )}
            </Nav>
            <Nav className="align-items-lg-center gap-lg-2">
              {isAuthenticated && (
                <Form.Select
                  size="sm"
                  className="global-client-filter"
                  aria-label="Filtro global de cliente"
                  value={selectedClientId ?? ''}
                  disabled={isLoadingClients}
                  onChange={(e) => {
                    const v = e.target.value
                    setSelectedClientId(v === '' ? null : Number(v))
                  }}
                  title={
                    isFiltering
                      ? 'Filtro activo: todo el sistema muestra solo este cliente'
                      : 'Sin filtro: se muestra el alcance completo de tu rol'
                  }
                >
                  <option value="">Todos los clientes</option>
                  {clients.map((c) => (
                    <option key={c.id} value={c.id}>
                      {clientLabel(c)}
                    </option>
                  ))}
                </Form.Select>
              )}
              {isAuthenticated ? (
                <>
                  <NotificationBell />
                  <NavDropdown title={user?.username || 'Usuario'} id="user-dropdown">
                    <NavDropdown.Item
                      href={getDjangoAdminUrl('/admin/')}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Admin
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item onClick={handleLogout}>
                      Cerrar Sesión
                    </NavDropdown.Item>
                  </NavDropdown>
                </>
              ) : (
                <Nav.Link as={Link} to="/login">
                  Iniciar Sesión
                </Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {isAuthenticated && isFiltering && (
        <div className="global-client-filter-banner">
          Vista filtrada por cliente. Cambia el selector del encabezado o elige &quot;Todos los clientes&quot; para quitar el filtro.
        </div>
      )}

      <main className="main-content">
        {children}
      </main>

      <footer className="main-footer bg-primary text-white text-center py-3 mt-5">
        <Container>
          <p className="mb-0 fw-bold">
            © Arithmos 360°
          </p>
        </Container>
      </footer>
    </div>
  )
}

export default Layout
